import { toast } from 'react-toastify';

import { _upload } from '../../../utils/network';

const MAX_IMAGE_SIZE_MB = 2;
const SETUP_FLAG = '__etebarImageUploadDialogReady';

const setButtonLabel = (button, label) => {
	const element = button.getElement?.();
	if (!element)
		return;
	const labelNode = element.findOne('.cke_dialog_ui_button');
	if (labelNode)
		labelNode.setText(label);
};

export const registerImageUploadDialog = (CKEDITOR, getLabels) => {
	if (!CKEDITOR || CKEDITOR[SETUP_FLAG])
		return;
	CKEDITOR[SETUP_FLAG] = true;

	CKEDITOR.on('dialogDefinition', ev => {
		if (ev.data.name !== 'image')
			return;

		const infoTab = ev.data.definition.getContents('info');
		if (!infoTab)
			return;

		const browseButton = infoTab.get('browse');
		if (!browseButton)
			return;

		const labels = typeof getLabels === 'function' ? getLabels() : (getLabels || {});
		const uploadLabel = labels.upload || 'Upload';
		const uploadingLabel = labels.uploading || 'Uploading...';
		const imageOnlyMessage = labels.imageOnlyMessage || 'Only image files are allowed';
		const maxSizeMessage = labels.maxSizeMessage || `Max file size: ${MAX_IMAGE_SIZE_MB} MB`;
		const apiMessageKey = labels.apiMessageKey || 'message_fa';

		browseButton.hidden = false;
		browseButton.label = uploadLabel;
		browseButton.filebrowser = undefined;
		browseButton.style = 'display:inline-block;margin-top:14px;min-width:110px;';
		browseButton.onClick = function onUploadClick() {
			const dialog = this.getDialog();
			const button = this;
			const fileInput = document.createElement('input');
			fileInput.type = 'file';
			fileInput.accept = 'image/*';
			fileInput.style.display = 'none';

			fileInput.addEventListener('change', async () => {
				const file = fileInput.files?.[0];
				fileInput.remove();
				if (!file)
					return;

				if (!file.type || !file.type.startsWith('image/')) {
					toast.warn(imageOnlyMessage);
					return;
				}
				if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
					toast.warn(maxSizeMessage);
					return;
				}

				button.disable();
				setButtonLabel(button, uploadingLabel);
				button.getElement()?.addClass('cke-image-upload-loading');

				try {
					const data = new FormData();
					data.append('file', file);
					data.append('upload_file', true);
					const response = await _upload('/upload', data);

					if (response?.code === 200) {
						const imageUrl = (response.data?.image_address || '').replace('https', 'http');
						const urlField = dialog.getContentElement('info', 'txtUrl');
						if (urlField && imageUrl) {
							urlField.setValue(imageUrl);
							urlField.fire('change');
							// Keep uploaded images fluid in the editor (full width, auto height).
							const applyFluidSize = () => {
								try {
									dialog.setValueOf('info', 'txtWidth', '100%');
									dialog.setValueOf('info', 'txtHeight', '');
								} catch (e) {}
							};
							applyFluidSize();
							setTimeout(applyFluidSize, 300);
						}
					} else {
						toast.error(response?.[apiMessageKey] || 'Upload failed');
					}
				} catch (error) {
					toast.error(error?.message || 'Upload failed');
				} finally {
					button.getElement()?.removeClass('cke-image-upload-loading');
					setButtonLabel(button, uploadLabel);
					button.enable();
				}
			});

			document.body.appendChild(fileInput);
			fileInput.click();
		};
	});
};
